import { useEffect } from "react";
import { Modal, Input, Form } from "antd";

const ModalWithTextInput = ({ onSubmit, isOpen, onCancel, title, label, isLoadind }) => {
  const [form] = Form.useForm();

  // Reset form when modal closes
  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen]);

  const handleOk = () => {
    form.validateFields()
      .then((values) => {
        console.log("Submitted:", values);
        onSubmit(values);
      })
      .catch((info) => console.log("Validation Failed:", info));
  };

  return (
    <Modal title={title} open={isOpen} onOk={handleOk} onCancel={onCancel} 
    okButtonProps={{ disabled: isLoadind }} 
    confirmLoading={isLoadind}
      cancelButtonProps={{ disabled: isLoadind }}  >
      <Form form={form} layout="vertical">
        <Form.Item 
          label={label}
          name="inputField"
          rules={[{ required: true, message: "This field is required!" }]}
        >
          <Input.TextArea placeholder="Enter your message..." rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalWithTextInput;
